import React from 'react'
import './styles.scss'
import { Spin } from 'antd'
import FileItem   from './file-item'
import EmptyState from '../../Shared/EmptyState'

export default ({ files,
                  files_loading,
                  is_agent_running,
                  on_select,
                  on_delete,
                  on_refresh,
                  on_launch_agent,
                  on_navigate,
                  on_load_more,
                  on_upload,
                  has_more
}) => (
  <div className={'files'}>
    {
      (files_loading && (!files || files.length === 0)) ?
        <Spin size='small' tip='Loading...' style={{ margin: 'auto auto' }} /> :

        ((!files || files.length === 0) ?
            <EmptyState click_text={is_agent_running ? 'Refresh' : 'Launch transfer agent'} on_click={()=> is_agent_running ? on_refresh() : on_launch_agent()}/> :
          (files.map((file, index) =>
              <FileItem key         = {index}
                        file        = {file}
                        on_select   = {on_select}
                        on_delete   = {on_delete}
                        on_navigate = {on_navigate}
                        on_upload   = {on_upload}
              />)
        ))
    }
  </div>
)
